import { render, staticRenderFns } from "./clientCreate.vue?vue&type=template&id=720c65ad"
import script from "./clientCreate.vue?vue&type=script&lang=js"
export * from "./clientCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports